import {
  DTNode,
  DTWeightedNode,
  WeightedNodeOutputData,
} from 'common/src/modules/decisionTree/decisionTree.types';
import {ServerNode} from 'common/src/modules/nodes/nodes.types';
import {trimDescription} from 'common/src/modules/campaigns/utils/trimDescription';

export function serializeWeightedNode(node: DTNode, newNode: ServerNode) {
  const weightNode = node as DTWeightedNode;

  return {
    ...newNode,
    description: trimDescription(newNode.description),
    shouldSplitAudience: weightNode.shouldSplitAudience,
    outputs: (weightNode.outputs as WeightedNodeOutputData[]).map((output) => {
      return {nodeId: output.nodeId, weight: output.weight, id: output.id, name: output.name};
    }),
  };
}

